import { Component, OnInit, Input } from '@angular/core';
import { RestService } from 'src/app/services/rest/rest.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { Stock, Transaction } from 'src/app/interfaces/stock';
import { ModalController, AlertController } from '@ionic/angular';
import { AddStockComponent } from 'src/app/components/add-stock/add-stock.component';

@Component({
  selector: 'app-stock',
  templateUrl: './stock.page.html',
  styleUrls: ['./stock.page.scss'],
})
export class StockPage implements OnInit {
  currentPage = 0;
  maxPage = 0;
  columns = [
    {
      field: 'productName',
      name: 'TIPO',
      width: 20
    },
    {
      field: 'palete',
      name: 'PALETS COMPLETOS',
      width: 20
    },
    {
      field: 'total',
      name: 'TOTAL UNIDADES Palete',
      width: 20
    },
    {
      field: 'sueltas',
      name: 'UNIDADES SUELTAS',
      width: 20
    },
    {
      field: 'total_ud',
      name: 'TOTAL UNIDADES',
      width: 20
    }
  ];

  columnsHistory = [
    {
      field: 'createdAt',
      name: 'Fecha',
      width: 20
    },
    {
      field: 'creator',
      name: 'Responsable',
      width: 20
    },
    {
      field: 'comment',
      name: 'Comentario',
      width: 20
    },
    {
      field: 'prod1',
      name: 'CUBITO VOGT',
      width: 18
    },
    {
      field: 'prod2',
      name: 'CUBITO SCOTSMAN',
      width: 18
    },
    {
      field: 'prod3',
      name: 'HIELO PILEE',
      width: 18
    },
    {
      field: 'prod4',
      name: 'ESCAMA RED',
      width: 18
    },
    {
      field: 'prod5',
      name: 'ESCAMA CUAD',
      width: 18
    },
    {
      field: 'prod6',
      name: 'HIELO CUADRADO',
      width: 18
    },
    {
      field: 'prod7',
      name: 'BARRA',
      width: 18
    },
    {
      field: 'prod8',
      name: 'BLOQUES',
      width: 18
    },
    {
      field: 'prod9',
      name: 'HIELO SECO',
      width: 18
    },
    {
      field: 'prod10',
      name: 'HIELO ESPECIAL',
      width: 18
    },
    {
      field: 'prod11',
      name: 'CUBO 5X5',
      width: 18
    }, {
      field: 'prod12',
      name: 'LINGOTE 4X12',
      width: 18
    }, {
      field: 'prod13',
      name: 'ESFERAS 6CM',
      width: 18
    }, {
      field: 'prod14',
      name: 'CUBO 5,5 X 5,5',
      width: 18
    }, {
      field: 'prod15',
      name: 'CUBO 5X7',
      width: 18
    }, {
      field: 'prod16',
      name: 'LINGOTE 3X15',
      width: 18
    }, {
      field: 'prod17',
      name: 'ESFERAS 3CM',
      width: 18
    },
  ]

  lines: any[] = [];
  linesHistory: any[] = [];
  // Guardar aquí los nuevos datos rellenados para comparar con los que ya había
  newResults = [];
  currentResults = [];
  products = [];

  cubitoVogtValue = 0;
  scotsmanValue = 0;
  pileeValue = 0;
  escamaRedValue = 0;
  escamaCuadValue = 0;
  cuadradoValue = 0;
  barraValue = 0;
  bloquesValue = 0;
  secoValue = 0;
  especialValue = 0;
  cubo5x5Value = 0;
  lingote4x12Value = 0;
  esferas6cmValue = 0;
  cubo55x55Value = 0;
  cubo5x7Value = 0;
  lingote3x15Value = 0;
  esferas3cmValue = 0;

  constructor(private rest: RestService,
    private utils: UtilsService,
    private modal: ModalController,
    public alert: AlertController
  ) { }

  async ngOnInit() {
    await this.getAllStock();
    await this.getProducts();
    await this.getAllStockList();
  }

  async getProducts() {
    const resp: any = await this.rest.getProducts(1, 1000);
    if (resp.body && resp.body.records) {
      this.products = resp.body.records.filter(elem => (elem._id !== '5ef5e43bdd4795f0c32a1530')
        && elem._id !== '5ef5e43bdd4795f0c32a152f');
      console.log(this.products);
      //console.log("Estamos sacando info" + this.lines);
    }
  }
  async showAlert() {
    const alert = await this.alert.create({
      header: '¿Qué desea hacer?',
      message: 'Elija una opción',
      buttons: [
        {
          text: 'Añadir Stock',
          handler: async () => {
            await this.addNew(true);
          }
        }, {
          text: 'Ajustar Stock',
          handler: async () => {
            await this.addNew(false);
          }
        }
      ]
    });
    await alert.present();
  }

  async saveValues(data) {
    console.log(this.lines);
    try {
      await this.utils.showLoading();
      console.log(data);
      const lines: Stock = {
        // transaction: [
        //   {
        //     product: '5eb9c9e3d0ca13a4332680dc',
        //     quantity: data['5eb9c9e3d0ca13a4332680dc']
        //   },
        //   {
        //     product: '5eb9c9e3d0ca13a4332680db',
        //     quantity: data['5eb9c9e3d0ca13a4332680db']
        //   },
        //   {
        //     product: '5eb9c9e3d0ca13a4332680d9',
        //     quantity: data['5eb9c9e3d0ca13a4332680d9']
        //   },
        //   {
        //     product: '5eb9c9e3d0ca13a4332680da',
        //     quantity: data['5eb9c9e3d0ca13a4332680da']
        //   },
        //   {
        //     product: '5ef5e43bdd4795f0c32a152b',
        //     quantity: data['5ef5e43bdd4795f0c32a152b']
        //   },
        //   {
        //     product: '5ea75b95ece96f572f598255',
        //     quantity: data['5ea75b95ece96f572f598255']
        //   },
        //   {
        //     product: '5ef5e43bdd4795f0c32a152c',
        //     quantity: data['5ef5e43bdd4795f0c32a152c']
        //   },
        //   {
        //     product: '5ef5e43bdd4795f0c32a152d',
        //     quantity: data['5ef5e43bdd4795f0c32a152d']
        //   },
        //   {
        //     product: '5ef5e43bdd4795f0c32a152e',
        //     quantity: data['5ef5e43bdd4795f0c32a152e']
        //   },
        //   {
        //     product: '5ef5e43bdd4795f0c32a1531',
        //     quantity: data['5ef5e43bdd4795f0c32a1531']
        //   }
        // ],
        comment: data.comment,
        creator: data.creator
      };
      lines.transaction = [];
      this.products.forEach(
        product => {
          lines.transaction.push({
            product: product._id,
            quantity: data[product._id]
          })
        }
      );
      console.log(lines);
      const resp = await this.rest.createStock(lines);
      if (resp !== false) {
        await this.utils.hideLoading();
        await this.utils.showToast('Stock actualizado correctamente', 'success');
        await this.getAllStock();
        await this.getAllStockList();
        // window.location.reload();
      } else {
        await this.utils.hideLoading();
        await this.utils.showToast('Error al actualizar el stock', 'danger');
      }

    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
      await this.utils.showToast('Error al actualizar el stock', 'danger');
    }
  }

  async restoreValues(data) {
    // ///////////////////Cubito Vogt///////////////////
    const cubitoNew: any = Object.values(data)[2];
    const cubitoStock: any = this.lines[0].total_ud;
    if (cubitoNew) {
      this.cubitoVogtValue = cubitoNew - cubitoStock;
    }

    // ///////////////////ScotsMan///////////////////
    const scotsManNew: any = Object.values(data)[3];
    const scotsManStock: any = this.lines[1].total_ud;
    if (scotsManNew) {
      this.scotsmanValue = scotsManNew - scotsManStock;
    }

    // ///////////////////Pilee///////////////////
    const pileeNew: any = Object.values(data)[4];
    const pileeStock: any = this.lines[2].total_ud;
    if (pileeNew) {
      this.pileeValue = pileeNew - pileeStock;
    }
    // ///////////////////Escama Red///////////////////
    const escamaRedNew: any = Object.values(data)[5];
    const escamaRedStock: any = this.lines[3].total_ud;
    if (escamaRedNew) {
      this.escamaRedValue = escamaRedNew - escamaRedStock;
    }
    // ///////////////////Escama cuad///////////////////
    const escamaCuadNew: any = Object.values(data)[6];
    const escamaCuadStock: any = this.lines[4].total_ud;
    if (escamaCuadNew) {
      this.escamaCuadValue = escamaCuadNew - escamaCuadStock;
    }
    // ///////////////////Hielo Cuadrado///////////////////
    const cuadradoNew: any = Object.values(data)[7];
    const cuadradoStock: any = this.lines[5].total_ud;
    if (cuadradoNew) {
      this.cuadradoValue = cuadradoNew - cuadradoStock;
    }
    // ///////////////////Barra///////////////////
    const barraNew: any = Object.values(data)[8];
    const barraStock: any = this.lines[6].total_ud;
    if (barraNew) {
      this.barraValue = barraNew - barraStock;
    }
    // ///////////////////Bloques///////////////////
    const bloquesNew: any = Object.values(data)[9];
    const bloquesStock: any = this.lines[7].total_ud;
    if (bloquesNew) {
      this.bloquesValue = bloquesNew - bloquesStock;
    }
    // ///////////////////Hielo Seco///////////////////
    const secoNew: any = Object.values(data)[10];
    const secoStock: any = this.lines[8].total_ud;
    if (secoNew) {
      this.secoValue = secoNew - secoStock;
    }
    // ///////////////////Hielo Especial///////////////////
    const especialNew: any = Object.values(data)[11];
    const especialStock: any = this.lines[9].total_ud;
    if (especialNew) {
      this.especialValue = especialNew - especialStock;
    }
    // ///////////////////Cubo 5x5///////////////////
    const cubo5x5New: any = Object.values(data)[12];
    const cubo5xStock: any = this.lines[10].total_ud;
    if (cubo5x5New) {
      this.cubo5x5Value = cubo5x5New - cubo5xStock;
    }
    // ///////////////////Lingote 4x12///////////////////
    const lingote4x12New: any = Object.values(data)[13];
    const lingote4x12Stock: any = this.lines[11].total_ud;
    if (lingote4x12New) {
      this.lingote4x12Value = lingote4x12New - lingote4x12Stock;
    }
    // ///////////////////Esferas 6cm///////////////////
    const esferas6cmNew: any = Object.values(data)[14];
    const esferas6cmStock: any = this.lines[12].total_ud;
    if (esferas6cmNew) {
      this.esferas6cmValue = esferas6cmNew - esferas6cmStock;
    }
    // ///////////////////Cubo 5,5 x 5,5///////////////////
    const cubo55x55New: any = Object.values(data)[15];
    const cubo55x5Stock: any = this.lines[13].total_ud;
    if (cubo55x55New) {
      this.cubo55x55Value = cubo55x55New - cubo55x5Stock;
    }
    // ///////////////////Cubo 5x7///////////////////
    const cubo5x7New: any = Object.values(data)[16];
    const cubo5x7Stock: any = this.lines[14].total_ud;
    if (cubo5x7New) {
      this.cubo5x7Value = cubo5x7New - cubo5x7Stock;
    }
    // ///////////////////Lingote 3x15///////////////////
    const lingote3x15New: any = Object.values(data)[17];
    const lingote3x15Stock: any = this.lines[15].total_ud;
    if (lingote3x15New) {
      this.lingote3x15Value = lingote3x15New - lingote3x15Stock;
    }
    // ///////////////////Esferas 3cm///////////////////
    const esferas3cmNew: any = Object.values(data)[18];
    const esferas3cmStock: any = this.lines[16].total_ud;
    if (esferas3cmNew) {
      this.esferas3cmValue = esferas3cmNew - esferas3cmStock;
    }
    try {
      await this.utils.showLoading();
      console.log(data);
      const lines: Stock = {
        transaction: [
          {
            product: '5eb9c9e3d0ca13a4332680dc',
            quantity: this.cubitoVogtValue
          },
          {
            product: '5eb9c9e3d0ca13a4332680db',
            quantity: this.scotsmanValue
          },
          {
            product: '5eb9c9e3d0ca13a4332680d9',
            quantity: this.pileeValue
          },
          {
            product: '5eb9c9e3d0ca13a4332680da',
            quantity: this.escamaRedValue
          },
          {
            product: '5ef5e43bdd4795f0c32a152b',
            quantity: this.escamaCuadValue
          },
          {
            product: '5ea75b95ece96f572f598255',
            quantity: this.cuadradoValue
          },
          {
            product: '5ef5e43bdd4795f0c32a152c',
            quantity: this.barraValue
          },
          {
            product: '5ef5e43bdd4795f0c32a152d',
            quantity: this.bloquesValue
          },
          {
            product: '5ef5e43bdd4795f0c32a152e',
            quantity: this.secoValue
          },
          {
            product: '5ef5e43bdd4795f0c32a1531',
            quantity: this.especialValue
          },
          {
            product: '6509a1e01bb0978fd8b5b15f',
            quantity: this.cubo5x5Value
          },
          {
            product: '6509a4241bb0978fd8b5b161',
            quantity: this.lingote4x12Value
          },
          {
            product: '650dbb3eb78327095c20a226',
            quantity: this.esferas6cmValue
          },
          {
            product: '650aae4834900b974d3fba94',
            quantity: this.cubo55x55Value
          },
          {
            product: '650aae7934900b974d3fba95',
            quantity: this.cubo5x5Value
          },
          {
            product: '650aae9a34900b974d3fba96',
            quantity: this.lingote3x15Value
          },
          {
            product: '650aaebe34900b974d3fba97',
            quantity: this.esferas3cmValue
          }
        ],
        comment: data.comment,
        creator: data.creator
      };
      console.log(lines);
      const resp = await this.rest.createStock(lines);
      if (resp !== false) {
        await this.utils.hideLoading();
        await this.utils.showToast('Stock actualizado correctamente', 'success');
        // window.location.reload();
        await this.getAllStock();
        await this.getAllStockList();
      } else {
        await this.utils.hideLoading();
        await this.utils.showToast('Error al actualizar el stock', 'danger');
      }

    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
      await this.utils.showToast('Error al actualizar el stock', 'danger');
    }
  }

  async getAllStock() {
    this.lines = [];
    try {
      await this.utils.showLoading();

      // const respAll: any = await this.rest.getAllStockList();
      // console.log(respAll.body);
      const resp: any = await this.rest.getStocks();
      if (resp !== false) {
        console.log(resp.body.records);
        const currentResults: Stock = resp.body.records;
        if (currentResults) {
          const line: Stock = {
            _id: currentResults._id,
            transaction: currentResults.transaction,
            createdAt: currentResults.createdAt
          };
          console.log(line);
          line.transaction.forEach(elem => {
            if ((elem as any).product._id !== '5ef5e43bdd4795f0c32a1530' &&
              (elem as any).product._id !== '5ef5e43bdd4795f0c32a152f') {

              this.lines.push({
                productName: (elem.product as any).name,
                palete: Math.floor(elem.total / 99),
                total: 99,
                sueltas: elem.total - Math.floor(elem.total / 99) * 99,
                total_ud: elem.total
              });
            }
          });
        }
        console.log(this.lines);
        await this.utils.hideLoading();
      } else {
        await this.utils.hideLoading();
        await this.utils.showToast('Error al obtener el stock', 'danger');
      }
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
      await this.utils.showToast('Error al obtener el stock', 'danger');
    }
  }

  async getAllStockList() {
    this.linesHistory = [];
    try {
      await this.utils.showLoading();
      const resp: any = await this.rest.getAllStockList(this.currentPage, 20);
      console.log(resp);
      this.maxPage = Math.ceil((resp.body.total / 20) + ((resp.body.total % 20 > 0) ? 1 : 0));
      if (resp !== false) {
        console.log(resp.body.records);
        const currentResults: Stock[] = resp.body.records;
        console.log(currentResults);
        if (currentResults) {
          currentResults.forEach(elem => {
            this.linesHistory.push({
              createdAt: elem.createdAt,
              creator: elem.creator ? (elem.creator as any).firstName : '',
              comment: elem.comment ? (elem.comment as any).firstName : '',
              prod1: elem.transaction.length > 0 ? elem.transaction[0].total : '-',
              prod2: elem.transaction.length > 1 ? elem.transaction[1].total : '-',
              prod3: elem.transaction.length > 2 ? elem.transaction[2].total : '-',
              prod4: elem.transaction.length > 3 ? elem.transaction[3].total : '-',
              prod5: elem.transaction.length > 4 ? elem.transaction[4].total : '-',
              prod6: elem.transaction.length > 5 ? elem.transaction[5].total : '-',
              prod7: elem.transaction.length > 6 ? elem.transaction[6].total : '-',
              prod8: elem.transaction.length > 7 ? elem.transaction[7].total : '-',
              prod9: elem.transaction.length > 8 ? elem.transaction[8].total : '-',
              prod10: elem.transaction.length > 9 ? elem.transaction[9].total : '-',
              prod11: elem.transaction.length > 10 ? elem.transaction[10].total : '-',
              prod12: elem.transaction.length > 11 ? elem.transaction[11].total : '-',
              prod13: elem.transaction.length > 12 ? elem.transaction[12].total : '-',
              prod14: elem.transaction.length > 13 ? elem.transaction[13].total : '-',
              prod15: elem.transaction.length > 14 ? elem.transaction[14].total : '-',
              prod16: elem.transaction.length > 15 ? elem.transaction[15].total : '-',
              prod17: elem.transaction.length > 16 ? elem.transaction[16].total : '-'
            });
          });
        }

        this.linesHistory.forEach(lineHistory => {
          const time = new Date(lineHistory.createdAt).toLocaleTimeString('es-ES').slice(0, -3);
          lineHistory.createdAt = new Date(lineHistory.createdAt).toLocaleDateString('es-ES');
          lineHistory.createdAt = lineHistory.createdAt + ' - ' + time;
        })
        console.log(this.linesHistory);
        await this.utils.hideLoading();
      } else {
        await this.utils.hideLoading();
        await this.utils.showToast('Error al obtener el stock', 'danger');
      }
    } catch (error) {
      console.log(error);
      await this.utils.hideLoading();
      await this.utils.showToast('Error al obtener el stock', 'danger');
    }

  }

  async addNew(isAdd: boolean) {
    console.log('add new');
    const modal = await this.modal.create({
      component: AddStockComponent,
      componentProps: {
        isAdd
      }
    });
    await modal.present();
    const result = await modal.onWillDismiss();

    if (result && result.data && isAdd) {
      console.log(result.data);
      this.saveValues(result.data);
    }
    if (result && result.data && !isAdd) {
      console.log(result.data);
      this.restoreValues(result.data);
    }
  }

  pagination(event: any) {
    if ((this.currentPage + event >= 0) && (this.currentPage + event <= this.maxPage)) {
      this.currentPage += event;
    }
    console.log(this.currentPage);
    this.getAllStockList();
  }

  async refreshPage() {
    await this.getAllStock();
    await this.getProducts();
    await this.getAllStockList();
  }
}
